// Brand persistence so login screen, tab title, favicon & accent apply
// immediately (even before /auth/me resolves), for a single-tenant install.

export function hexToHsl(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hh, s, l = (max + min) / 2;
  if (max === min) { hh = 0; s = 0; }
  else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hh = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hh = (b - r) / d + 2; break;
      default: hh = (r - g) / d + 4;
    }
    hh /= 6;
  }
  return `${Math.round(hh * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function getBrand() {
  try {
    return {
      name: localStorage.getItem("brand_name") || "",
      logo: localStorage.getItem("brand_logo") || "",
      invert: localStorage.getItem("brand_invert") === "1",
      accent: localStorage.getItem("brand_accent") || "",
    };
  } catch {
    return { name: "", logo: "", invert: false, accent: "" };
  }
}

export function saveBrand(user) {
  if (!user) return;
  try {
    localStorage.setItem("brand_name", user.business_name || "");
    localStorage.setItem("brand_logo", user.logo_url || "");
    localStorage.setItem("brand_invert", user.logo_invert ? "1" : "0");
    localStorage.setItem("brand_accent", user.accent_color || "");
  } catch { /* ignore */ }
}

export function applyBrand(brand) {
  const name = brand?.name || "HomePix Ops";
  document.title = name;
  if (brand?.logo) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = brand.logo;
  }
  const root = document.documentElement;
  const hsl = brand?.accent ? hexToHsl(brand.accent) : null;
  if (hsl) {
    const [h, s, l] = hsl.replace(/%/g, "").split(" ").map(Number);
    // Matte theme uses a softer, desaturated take on the same brand hue.
    const muted = `${h} ${Math.min(s, 48)}% ${Math.min(Math.max(l, 62), 72)}%`;
    root.style.setProperty("--brand-primary", hsl);
    root.style.setProperty("--brand-muted", muted);
  } else {
    root.style.removeProperty("--brand-primary");
    root.style.removeProperty("--brand-muted");
  }
  root.style.removeProperty("--primary");
  root.style.removeProperty("--ring");
}
